module.exports = __webpack_public_path__ + "static/media/redFish.c9c513de.svg";